import { render, staticRenderFns } from "./ClientputList.vue?vue&type=template&id=81cbd412"
import script from "./ClientputList.vue?vue&type=script&lang=js"
export * from "./ClientputList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports